import ko from 'knockout';
import { Chart, BarElement, BarController, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';

Chart.register(BarElement, BarController, CategoryScale, LinearScale, Tooltip, Legend);

export function registerComponent() {
  ko.components.register('weather-chart', {
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new WeatherChartViewModel(params, componentInfo);
      },
    },
    template: '<canvas/>',
  });
}

function WeatherChartViewModel(params, componentInfo) {
  var data = params.data;
  new Chart(componentInfo.element.firstChild, {
    type: 'bar',
    data: {
      labels: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
      ],
      datasets: data.datasets,
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          ticks: {
            callback: function (value) {
              return value + ' ' + data.unit;
            },
          },
        },
      },
      plugins: {
        tooltip: {
          callbacks: {
            label: function (tooltipItem) {
              var label = tooltipItem.dataset.label || '';

              if (label) {
                label += ': ' + tooltipItem.formattedValue.replace('.', ',') + ' ' + data.unit;
              }
              return label;
            },
          },
        },
        legend: {
          position: 'bottom',
        },
      },
    },
  });
}
